export default function classListToArray(classList){
    let classes = []
    for (let cssClass of classList) {
      classes.push(cssClass);
    }
    return classes
  }